const containsNumber = (value: string) => /\d/.test(value)

export default containsNumber
